import type { Item } from './types';

/** Region boxes are final architectural surfaces authored as items — a wall niche, a floor
 * platform, a ceiling soffit — rather than furniture placed in the room. */
export function isRegion(item: Item): boolean {
  return item.modelRef.kind === 'local' && /^decor\.primitives\/1018\/1018-region-(Wall|Floor|Ceiling)Region-/.test(item.modelRef.id);
}
